/**
 * Returns the base URL the public site should use for API calls.
 *
 * On the live production domain (codeplanning.co.nz / www.codeplanning.co.nz)
 * we use a same-origin relative path so the browser never has to do a
 * cross-origin XHR — this is faster, more reliable, and (critically) renders
 * properly inside Google's Web Rendering Service which can be flaky on
 * cross-origin fetches during Live URL inspections.
 *
 * On preview / localhost we use the REACT_APP_BACKEND_URL the build was
 * bundled with.
 */
export function getApiBase() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "codeplanning.co.nz" || host === "www.codeplanning.co.nz") {
      return ""; // same-origin → API calls become /api/...
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const API = `${getApiBase()}/api`;
